<template>
  <div class="investReports">
    <div v-if="loading">
      <span
        ><v-progress-circular
          indeterminate
          :size="20"
          color="blue lighten-5"
          class="mr-2"
        ></v-progress-circular
        >Loading...</span
      >
    </div>
    <!--
    <v-simple-table v-if="reportList.length" class="reportsTable" dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Report title</th>
            <th class="text-left">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in reportList" :key="item.Name">
            <td><a :href="item.Link" target="_blank">{{ item.Name }}</a></td>
            <td>{{ item.Description }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  -->
    <InvestmentReports
      :investRunId="investRunId"
      :investRunUID="investRunUID"
      reportType="Investment"
      :setParams="false"
    ></InvestmentReports>
    <v-alert v-if="!isRunInvestSuccessful" type="error" outlined dense
      >Investment process failed</v-alert>
  </div>
</template>

<script>
import InvestmentReports from './InvestmentReports.vue'

export default {
  name: 'InvestReports',
  components: {InvestmentReports},
  props: { reportList: Array, loading: Boolean, isRunInvestSuccessful: Boolean, investRunId: Number, investRunUID: String},
};
</script>

<style></style>
